import { render } from "./ExpensesEdit.vue?vue&type=template&id=642081a9&scoped=true"
import script from "./ExpensesEdit.vue?vue&type=script&lang=js"
export * from "./ExpensesEdit.vue?vue&type=script&lang=js"

import "./ExpensesEdit.vue?vue&type=style&index=0&id=642081a9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642081a9"]])

export default __exports__